import { isWeb } from 'tamagui'
import * as WebBrowser from 'expo-web-browser'

export function openWebBrowser(url: string, shouldOpenInNewTab = false) {
  if (isWeb) {
    if (shouldOpenInNewTab) {
      // noopener: a aba aberta (checkout, página do produtor) não ganha acesso a esta.
      window.open(url, '_blank', 'noopener')
    } else {
      window.location.href = url
    }
  } else {
    WebBrowser.openBrowserAsync(url)
  }
}
